export default {
  userLogged: false,
  confirmed: false,
  currentSchool: {},
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  grades: [
    'p1',
    'p2',
    'p3',
    'p4',
    'p5',
    'p6',
    'p7',
    'p8',
    's1',
    's2',
    's3',
    's4',
    'College/University',
    'Dropped Out',
    'Other',
  ],
  groupTypes: ['Module', 'Maintenance'],
  adminAreas: {
    Malawi: {
      Northern: [
        'Chitipa',
        'Karonga',
        'Likoma',
        'Mzimba',
        'Nkhata Bay',
        'Rumphi',
      ],
      Central: [
        'Dedza',
        'Dowa',
        'Kasungu',
        'Lilongwe',
        'Mchinji',
        'Nkhotakota',
        'Ntcheu',
        'Ntchisi',
        'Salima',
      ],
      Southern: [
        'Balaka',
        'Blantyre',
        'Chikhwawa',
        'Machinga',
        'Mangochi',
        'Mulanje',
        'Mwanza',
        'Neno',
        'Nsanje',
        'Phalombe',
        'Thyolo',
        'Zomba',
      ],
    },
    Namibia: {
      Kunene: [
        'Epupa',
        'Kamanjab',
        'Khorixas',
        'Opuwo Rural',
        'Opuwo Urban',
        'Outjo',
        'Sesfontein',
      ],
      Omusati: [
        'Anamulenge',
        'Elim',
        'Etayi',
        'Ogongo',
        'Okahao',
        'Okalongo',
        'Onesi',
        'Oshikuku',
        'Otamanzi',
        'Outapi',
        'Ruacana',
        'Tsandi',
      ],
      Oshana: [
        'Okaku',
        'Okatana',
        'Okatyali',
        'Ompundja',
        'Ondangwa Rural',
        'Ondangwa Urban',
        'Ongwediva',
        'Oshakati East',
        'Oshakati West',
        'Uukwiyu',
        'Uuvudhiya',
      ],
      Ohangwena: [
        'Eenhana',
        'Endola',
        'Engela',
        'Epembe',
        'Ohangwena',
        'Okongo',
        'Omulonga',
        'Omundaungilo',
        'Ondobe',
        'Ongenga',
        'Oshikango',
        'Oshikunde',
      ],
      Oshikoto: [
        'Eengodi',
        'Guinas',
        'Nehale lyaMpingana',
        'Okankolo',
        'Olukonda',
        'Omuntele',
        'Omuthiyagwiipundi',
        'Onayena',
        'Oniipa',
        'Onyaanya',
        'Tsumeb',
      ],
      'Kavango West': [
        'Kapako',
        'Mankumpi',
        'Mpungu',
        'Musese',
        'Ncamangoro',
        'Ncuncuni/Rundu Rural West',
        'Nkurenkuru',
        'Tondoro',
      ],
      'Kavango East': [
        'Mashare',
        'Mukwe',
        'Ndiyona',
        'Ndonga Linena',
        'Rundu Rural/Rundu Rural East',
        'Rundu Urban',
      ],
      Zambezi: [
        'Judea Lyaboloma',
        'Kabbe North',
        'Kabbe South',
        'Katima Mulilo Rural',
        'Katima Mulilo Urban',
        'Kongola',
        'Linyanti',
        'Sibbinda',
      ],
      Erongo: [
        'Arandis',
        'Dâures',
        'Karibib',
        'Omaruru',
        'Swakopmund',
        'Walvis Bay Rural',
        'Walvis Bay Urban',
      ],
      Otjozondjupa: [
        'Grootfontein',
        'Okahandja',
        'Okakarara',
        'Omatako',
        'Otavi',
        'Otjiwarongo',
        'Tsumkwe',
      ],
      Omaheke: [
        'Aminuis',
        'Epukiro',
        'Gobabis',
        'Kalahari',
        'Otjinene',
        'Otjombinde',
        'Okorukambe',
      ],
      Khomas: [
        'John Pandeni',
        'Katutura Central',
        'Katutura East',
        'Khomasdal North',
        'Moses ǁGaroëb',
        'Samora Machel',
        'Tobias Hainyeko',
        'Windhoek East',
        'Windhoek Rural',
        'Windhoek West',
      ],
      Hardap: [
        'Aranos',
        'Daweb',
        'Gibeon',
        'Mariental Rural',
        'Mariental Urban',
        'Rehoboth Rural',
        'Rehoboth Urban East',
        'Rehoboth Urban West',
      ],
      '!Karas': [
        'Berseba',
        'Karasburg East',
        'Karasburg West',
        'Keetmanshoop Rural',
        'Keetmanshoop Urban',
        'ǃNamiǂNûs',
        'Oranjemund',
      ],
    },
    Uganda: [],
    Zambia: {
      Central: [
        'CHIBOMBO',
        'CHISAMBA',
        'CHITAMBO',
        'ITEZHI-TEZHI',
        'KABWE',
        'KAPIRI MPOSHI',
        'LUANO',
        'MKUSHI',
        'MUMBWA',
        'NGABWE',
        'SERENJE',
      ],
      Copperbelt: [
        'CHILILABOMBWE',
        'CHINGOLA',
        'KALULUSHI',
        'KITWE',
        'LUANSHYA',
        'LUFWANYAMA',
        'MASAITI',
        'MPONGWE',
        'MUFULIRA',
        'NDOLA',
      ],
      Eastern: [
        'CHADIZA',
        'CHIPATA',
        'KATETE',
        'LUNDAZI',
        'MAMBWE',
        'NYIMBA',
        'PETAUKE',
        'SINDA',
        'VUBWI',
      ],
      Luapula: [
        'CHEMBE',
        'CHIENGI',
        'CHIPILI',
        'KAWAMBWA',
        'LUNGA',
        'MANSA',
        'MILENGE',
        'MWANSABOMBWE',
        'MWENSE',
        'NCHELENGE',
        'SAMFYA',
      ],
      Lusaka: [
        'CHILANGA',
        'CHIRUNDU',
        'CHONGWE',
        'KAFUE',
        'LUANGWA',
        'LUSAKA',
        'RUFUNSA',
        'SHIBUYUNJI',
      ],
      Muchinga: [
        'CHAMA',
        'CHINSALI',
        'ISOKA',
        'MAFINGA',
        'MPIKA',
        'NAKONDE',
        "SHIWANG'ANDU",
      ],
      Northern: [
        'CHILUBI',
        'KAPUTA',
        'KASAMA',
        'LUWINGU',
        'MBALA',
        'MPOROKOSO',
        'MPULUNGU',
        'MUNGWI',
        'NSAMA',
      ],
      'North Western': [
        'CHAVUMA',
        'IKELENGE',
        'KABOMPO',
        'KASEMPA',
        'MANYINGA',
        'MUFUMBWE',
        'MWINILUNGA',
        'SOLWEZI',
        'ZAMBEZI',
      ],
      Southern: [
        'CHIKANKATA',
        'CHOMA',
        'GWEMBE',
        'KALOMO',
        'KAZUNGULA',
        'LIVINGSTONE',
        'MAZABUKA',
        'MONZE',
        'NAMWALA',
        'PEMBA',
        'SIAVONGA',
        'SINAZONGWE',
        'ZIMBA',
      ],
      Western: [
        'KALABO',
        'KAOMA',
        'LIMULUNGA',
        'LUAMPA',
        'LUKULU',
        'MITETE',
        'MONGU',
        'MULOBEZI',
        'MWANDI',
        'NALOLO',
        'NKEYEMA',
        'SENANGA',
        'SESHEKE',
        "SHANG'OMBO",
        'SIKONGO',
        'SIOMA',
      ],
    },
  },
};